import React from 'react';
import { Container, Button } from 'react-bootstrap'; // Import Button
import './GivePage.css'; // We'll create this for styling

const GivePage = () => {
  // useEffect hook removed as it's no longer needed for the Payment Link

  return (
    <section className="section-padding give-page">
      <Container className="text-center">
        <h1 className="section-title mb-4">Support the Ministry</h1>
        <p className="lead mb-5">
          Your generous contributions help us continue our mission. Thank you for your support!
        </p>
        
        {/* Replace Stripe Buy Button with a Button linking to the Stripe Payment Link */}
        <div className="give-button-container">
          <Button 
            href="https://donate.stripe.com/28o5nwbdg4vUdMIfYZ" 
            variant="primary" 
            size="lg" 
            target="_blank" // Open link in a new tab
            rel="noopener noreferrer" // Security best practice for target="_blank"
          >
            Give Securely via Stripe
          </Button>
        </div>

        <p className="mt-5">
          Click the button above to securely give through Stripe.
        </p>
      </Container>
    </section>
  );
};

export default GivePage; 